module.exports = __webpack_public_path__ + "img/newFooterBig.c0a5b794.png";